<ndt-add-account-phone-numbers-view
   [callState]="callState$ | async"
   [form]="form"
   [existingPhoneNumbers]="existingPhoneNumbers"
   [existingExtensions]="existingExtensions"
   [isNew]="isNew"
   (formCanceled)="onCancel()"
   (formSubmitted)="onSubmit($event)"
>
</ndt-add-account-phone-numbers-view>
